import React, { useEffect, useState } from "react";
import CustomTable from "../Table";
import { getAllData } from "../../../Utils/firebaseServices";
import LoadingCircular from '../../../loader/LoadingCircular';



function Cients() {
  const [clients_data, setClients_data] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("clients", setClients_data);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
    
    if (loading) {
      return <LoadingCircular />;
    }
  return (
    <>
      <CustomTable data={clients_data} coll={["Name", "Email", "Phone"]} />
    </>
  );
}

export default Cients;
